import React, { Component } from "react";

class MessageBox extends Component {
  
  showAlert(msg,level) {
    const levels = {
      error: "myAlert myAlertDanger",
      warning: "myAlert myAlertWarning",
      success: "myAlert myAlertSuccess"
    }
    // 创建警告框元素
    var alertBox = document.createElement("div");
    alertBox.classList.add(...levels[level].split(' '));
    alertBox.textContent = msg;

    // 将警告框插入到页面中
    document.body.appendChild(alertBox);
    // 3秒后销毁警告框
    setTimeout(() => {
      alertBox.remove();  // 或者使用 alertBox.parentNode.removeChild(alertBox);
    }, 3000);
  }

  render() {
    const level = {
      error: "myAlert myAlertDanger",
      warning: "value2",
      success: "value3"
    }

    if (!this.props.msgBox.show) {
      return null;
    }

    return (
      <div  className={level[this.props.msgBox.level]} role="alert">
          {this.props.msgBox.msg} 
      </div>
    )
  }
}

const myMessageBox = new MessageBox();
export default myMessageBox;


// WEBPACK FOOTER //
// ./src/components/MessageBox.js